/*
 * @Author: shiyu
 * @Date: 2024-01-16 13:50:44
 * @LastEditTime: 2024-01-23 15:09:16
 * @FilePath: \indusyun-official-website\src\main.js
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Button, Select,Option,Input,Carousel, CarouselItem, Dialog} from 'element-ui';

Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Dialog)


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
